export default __webpack_public_path__ + "static/media/Img-Welcome.6caf597e.svg";